import { Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CustomAccordion, CustomAccordionDetails, CustomAccordionSummary, TitleSX } from './style';

interface Props {
	id: string;
	summary: string;
	children: React.ReactNode;
	defaultexpanded?: boolean;
	isfirst?: boolean;
	islast?: boolean;
}

export const DpAccordionHelpCenter: React.FC<React.PropsWithChildren<Props>> = ({
	id,
	summary,
	children,
	defaultexpanded,
	isfirst,
	islast,
	...props
}) => (
	<CustomAccordion
		disableGutters
		elevation={0}
		square={false}
		islast={islast}
		defaultExpanded={defaultexpanded}
		{...props}
	>
		<CustomAccordionSummary
			expandIcon={<ExpandMoreIcon />}
			id={id}
			isfirst={isfirst}
			aria-controls={id}
		>
			<Typography component="h3" sx={TitleSX}>
				{summary}
			</Typography>
		</CustomAccordionSummary>
		<CustomAccordionDetails>{children}</CustomAccordionDetails>
	</CustomAccordion>
);
